import moment from 'moment';

export const composeBarChartData = (data, fields, labelField, labelSuffix) =>
  fields.map(field =>
    data.map((row, i) =>
      ({
        x: `${i}-${row[labelField]}`,
        y: row[field],
        label: labelSuffix ? `${row[field]} ${labelSuffix}` : row[field],
      })));

export const shortenDateLabels = (data, dateField) => data.map((row, i) => {
  const check = moment(row[dateField]);
  return `${i}-${check.format('DD')}/${check.format('MM')}/${check.format('YY')}`;
});

const mrdXmlDailyAnalysis = {
  title: 'MRD XML Daily Analysis',
  type: 'stackedColumnWithLine',
  fields: [{
    name: 'Denested',
    color: '#00ef4c',
  }, {
    name: 'Missed',
    color: '#ef1810',
  }, {
    name: '% Denested',
    color: '#808080',
    type: 'minus',
  }],
  yTickFormat: amount => amount,
  xTickValues: data => shortenDateLabels(data, 'postalScanDate'),
  xTickFormat: t => t.replace(/(\d)+-/, ''),
  composeChartData: data => composeBarChartData(
    data,
    ['denested', 'missed'],
    'postalScanDate',
  ),
  composeLineData: data => composeBarChartData(
    data,
    ['pctDenested'],
    'postalScanDate',
  ),

};

export default {
  mrdXmlDailyAnalysis,
};
